export enum TimerLocation {
    Left,
    Center,
    Right,
}
